<div class="modal-header">
  <h4 class="modal-title">Gestão de Marcações</h4>
  <button type="button" (click)="onDismiss()" class="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
  <div class="row">
    <div class="col-12">
      <p *ngIf="hasValidRegistrations; else noRegistrations">
        Exibindo marcações realizadas por <strong>{{ employee.name | titlecase }}</strong>
        no dia <strong>{{ timeOccurrence.day | date: 'dd/MM/yyyy' }}</strong>.
      </p>
      <ng-template #noRegistrations>
        <h5 class="text-center">
          Sem marcações realizadas por <strong>{{ employee.name | titlecase }}</strong>
          no dia <strong>{{ timeOccurrence.day | date: 'dd/MM/yyyy' }}</strong>.
        </h5>
      </ng-template>
    </div>
  </div>

  <div class="table-responsive" *ngIf="hasValidRegistrations">
    <table class="table table-bordered table-hover text-center">
      <thead class="thead-light">
        <tr>
          <th>Marcações</th>
          <th>Horário</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of registrations" [hidden]="item.hour === '00:00:59'">
          <td>{{ item.label }}</td>
          <td>{{ item.hour }}</td>
          <td>
            <button *ngIf="!item.isOriginal" (click)="removeRegistration(item)" type="button"
              class="btn btn-sm btn-danger" rippleEffect title="Remover">
              <i data-feather="trash"></i>
            </button>
            <i *ngIf="item.isOriginal" data-feather="check-square" class="text-success" title="Marcação original">
            </i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="row align-items-end">
    <div class="col-md-8 col-12">
      <label class="form-control-label"for="newHour">Incluir Nova Marcação</label>
      <input id="newHour" type="time" class="form-control" placeholder="00:00" [(ngModel)]="newHour" required>
    </div>
    <div class="col-md-4 col-12">
      <button (click)="insertNewRegistration()" class="btn btn-primary w-100" rippleEffect>
        <i data-feather="plus"></i> Incluir
      </button>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="onDismiss()" rippleEffect>
    Fechar
  </button>
  <button type="button" (click)="updateRegistrations()" [disabled]="registrations.length % 2 !== 0"
    class="btn btn-success" rippleEffect>
    Ajustar Marcações
  </button>
</div>